'use client';
import * as React from 'react';

export const GridApiContext = React.createContext<unknown>(undefined);
